import { useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

export const PRIORITY_STYLES = {
  low: "bg-slate-50 text-slate-600 border-slate-200",
  medium: "bg-blue-50 text-blue-700 border-blue-200",
  high: "bg-amber-50 text-amber-800 border-amber-200",
  urgent: "bg-rose-50 text-rose-700 border-rose-200",
};

export const KIND_STYLES = {
  open: "bg-blue-50 text-blue-800 border-blue-200",
  converted: "bg-emerald-50 text-emerald-800 border-emerald-200",
  closed: "bg-slate-100 text-slate-600 border-slate-300",
};

export const CONTACT_TYPES = ["client", "prospect", "vendor", "other"];

export const useInquirySettings = () => {
  const [settings, setSettings] = useState(null);
  const reload = useCallback(() => api.get("/inquiry-settings").then((r) => setSettings(r.data)).catch(() => {}), []);
  useEffect(() => { reload(); }, [reload]);
  return [settings, reload];
};

export const fmtDateTime = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  return d.toLocaleString("en-IN", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });
};

export const localNowInput = () => {
  const d = new Date();
  d.setMinutes(d.getMinutes() - d.getTimezoneOffset());
  return d.toISOString().slice(0, 16);
};

export const Pill = ({ className, children, testid }) => (
  <span data-testid={testid} className={`inline-flex items-center text-[11px] px-2 py-0.5 rounded-sm border whitespace-nowrap ${className}`}>{children}</span>
);

export const localToday = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
};

export const cap = (s) => (s ? s[0].toUpperCase() + s.slice(1) : s);

export const PRIORITY_OPTIONS = ["low", "medium", "high", "urgent"].map((p) => ({ value: p, label: cap(p) }));

export const notifyInquiriesChanged = () => window.dispatchEvent(new Event("inquiries:changed"));
